export default __webpack_public_path__ + "static/media/viracon_linc.64256e28.svg";